$(window).on("load", function () {
  const $activeItem = $(".collection__hero-list-item--active");

  if ($activeItem.length > 0 && window.innerWidth < 1024) {
    const offset = $activeItem.prop("offsetLeft");
    const windowOffset = window.innerWidth / 2;
    const widthOffset = $activeItem.prop("scrollWidth") / 2;
    $(".collection__hero-list").animate(
      { scrollLeft: offset - windowOffset + widthOffset },
      300
    );
  }
});
